import { Loader2 } from "lucide-react";

export function RecordPageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surfaces-z2">
      <Loader2 className="size-8 animate-spin text-text-secondary" />
    </div>
  );
}
